/**
 * Data source factory for creating mock or live data adapters
 */

import { DataSourceAdapter, DataSourceConfig } from './types';
import { MockAdapter } from './adapters/mock';
import { LiveAdapter } from './adapters/live';
import { getConfig } from './config';

/**
 * Create data source adapter based on configuration
 */
export function createDataSource(config?: Partial<DataSourceConfig>): DataSourceAdapter {
  const finalConfig = { ...getConfig(), ...config };
  
  if (finalConfig.source === 'mock') {
    return new MockAdapter(finalConfig);
  } else {
    return new LiveAdapter(finalConfig);
  }
}

// Singleton instance
let dataSourceInstance: DataSourceAdapter | null = null;
let lastConfigSource: 'mock' | 'live' | null = null;

/**
 * Get singleton data source instance
 */
export function getDataSource(): DataSourceAdapter {
  const currentConfig = getConfig();
  
  // Reset instance if source has changed (e.g., from mock to live)
  if (lastConfigSource && lastConfigSource !== currentConfig.source) {
    console.warn(`Data source changed from ${lastConfigSource} to ${currentConfig.source}, resetting instance`);
    dataSourceInstance = null;
  }
  
  if (!dataSourceInstance) {
    dataSourceInstance = createDataSource();
    lastConfigSource = currentConfig.source;
  }
  return dataSourceInstance;
}

/**
 * Reset the singleton instance (useful for testing)
 */
export function resetDataSource(): void {
  dataSourceInstance = null;
}